import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/clientResource/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/clientResource/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/clientResource/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadClientResources(id, options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/v2/service-jobs/${id}/client-resources`, options)
      .then(({ data }) => {
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors,
        loaded: false,
        loading: false,
      }
    default:
      return state
  }
}
